// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/qoute-card-v2/qoute-card-v2.component.scss
// module id = 675
// module chunks = 0